import api from '../api';

import { ParamsBodyPostUpdatePassword } from 'utils/typeServices';

export const PostUpdatePassword = async ({ body }: { body: ParamsBodyPostUpdatePassword }) => {
    const bodyJson = JSON.stringify({
        PersonId: body.PersonId,
        Token: body.Token,
        confirmPassword: body.confirmPassword,
        password: body.password
    });

    try {
        const { data } = await api.post<{ Data: boolean }>('/v1/Cliente/UpdatePassword', bodyJson);

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
